// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__OPOal","validationTips":"StatementDescriptor_validationTips__q7i3N"};